export default __webpack_public_path__ + "static/media/bin.28eaf602.svg";